const styleSheet = () => ({
  downloadInquiries: {
    position: 'absolute',
    bottom: '21px',
    right: '90px',
    height: '28px',
    width: '315px',
  },
  downloadInquiriesButton: {
    paddingLeft: '1px',
    width: '25px',
    height: '25px',
    display: 'inline-block',
    position: 'absolute',
    right: '111px',
    border: '1.5px solid #CCD8E2',
    borderRadius: '4px',
    background: 'transparent',
  },
  downloadTitle: {
    top: '-15px',
    right: '145px',
    width: '167px',
    color: '#6E7680',
    height: '12px',
    position: 'absolute',
    fontSize: '9px',
    fontFamily: 'Avenir',
    fontWeight: 500,
    lineHeight: '12px',
    letterSpacing: 0,
    textTransform: 'uppercase',
  },
});

export default styleSheet;
